module.exports = __webpack_public_path__ + "static/media/finish.bb654e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/book/finish.png
// module id = 1021
// module chunks = 0